var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentityInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C19.6819 16 22.6666 13.0153 22.6666 9.33335C22.6666 5.65146 19.6819 2.66669 16 2.66669C12.3181 2.66669 9.33331 5.65146 9.33331 9.33335C9.33331 13.0153 12.3181 16 16 16Z",
    fill: "#1577DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16 19.3333C9.31998 19.3333 3.87994 23.8133 3.87994 29.3333C3.87994 29.7066 4.17328 30 4.54661 30H27.4534C27.8267 30 28.12 29.7066 28.12 29.3333C28.12 23.8133 22.68 19.3333 16 19.3333Z",
    fill: "#1577DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5733 19.6534C27.3733 18.4534 26.4267 18.84 25.6133 19.6534L20.8933 24.3734C20.7066 24.5601 20.5333 24.9067 20.4933 25.1601L20.24 26.96C20.1466 27.6134 20.6 28.0667 21.2533 27.9734L23.0533 27.72C23.3066 27.68 23.6666 27.5067 23.84 27.32L28.5599 22.6001C29.3866 21.8001 29.7733 20.8534 28.5733 19.6534Z",
    fill: "#1577DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityInfoIcon);
export default __webpack_public_path__ + "static/media/identityInfo-icon.dbde1ac5b24618330ef2b5983de59100.svg";
export { ForwardRef as ReactComponent };